import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class IdsProductsService {

  constructor(private http: HttpClient) { }

  //private endPointUrl: string = "https://idsdatahubdashboardapi.azurewebsites.net/api/";
  //private baseEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/"
  //private endPointUrl: string = "https://idsdatahubdashboardapinew.azurewebsites.net/api/";
   //private baseEndPoint: string = "https://idsdatahubdashboardapinew.azurewebsites.net"
     private endPointUrl: string = "https://fxdhdashboardapi.idsnext.live/api/";
  private baseEndPoint: string = "https://fxdhdashboardapi.idsnext.live/"


/* ----------
  //BWPOS - "PmsCode": "7757",
  
  //SarovarTLC - "PmsCode": "1999",

  //WBHIDCO - "PmsCode": "5960",

  //BWCRM - "PmsCode": "563",
  
  //CrystalStat (Onomo) - "PmsCode": "4951",

--------------- */

  // To load all property
  getIDSUsersProperties(UserId: any) {
    let data = { 'UserId': UserId }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.baseEndPoint + "api/DHUICM/GetCMHOTELS";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // SarovarTLC
  getSarovarTLCList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "SarovarTLC/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // BWPOS
  getBWPOSList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "BWPOS/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // WBHIDCO
  getWBHICOList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "WBHICO/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // BWCRM
  getBWCRMList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "BWCRM/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // BusyRoomRMD
  getBusyRoomRMDList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "BusyRoomRMD/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // CrystalStat (Onomo) - "PmsCode": "4951",
  getCrystalStatList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "CrystalStat/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }


  // Qatar Upload Logs - "PmsCode": "136",
  getQatarUploadList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Qatar/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // TIC Upload Logs - "PmsCode": "5693",
  getTICUploadList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "TIC/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }


  // IDEAS Upload Logs
  getIDEASUploadList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Ideas/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // FX GEM Upload Logs - "PmsCode": "5693",
  getFXGEMUploadList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Gem/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }


  // FX GEMKOT Download Logs
  getFXGEMKOTDownloadList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Gem/KOTLog";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // FX GEM Settlement Logs
  getFXGEMSettlementList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Gem/CheckOutBillLog";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

   // FX GEM CheckOut Notification Logs
   getFXGEMCheckOutList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Gem/CheckOutNotificationPostLog";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // FX GEM PreArrivalUpdate Logs
  getFXGEMPreArrivalUpdateList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Gem/PreArrivalUpdateGuestDetailsLog";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // Inspire Logs
  getInspireList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "Inspire/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // RatePing Upload Logs
  getRatePingList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "RatePing/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // CPO Upload Logs
  getCPOList(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any, UID: any, typ: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'UID': UID, 'typ': typ };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.endPointUrl + "CPO/Logs";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  /* Qatar Sync */
  getQatarSync()
    {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
          let endPoint = this.endPointUrl + "/Qatar/ReadQatar";
        return this.http.get(endPoint , { headers: headers })
          .map((response: Response) => JSON.parse(JSON.stringify(response)));
     }

     getQatarSyncError(PMSCUSTCODE:any)
    {
      let data = { 'Pmscode': PMSCUSTCODE}
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
          let endPoint = this.endPointUrl + "/Qatar/ReadQatarError";
        return this.http.post(endPoint,data , { headers: headers })
          .map((response: Response) => JSON.parse(JSON.stringify(response)));
     }
}